import React from "react";
import { Link } from "react-router";

export default class studentsIndexlinks extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        let buttons = [];

        if (this.props.buttons) {
            this.props.buttons.forEach((button) => {
                buttons.push(
                    <Link key={`button-${button.title}`} to={button.link} className={button.classname}>
                        {button.title}
                    </Link>
                );
            });
        }

        if (buttons.length > 0) {
            buttons = <div className="section-buttons">{buttons}</div>;
        }

        return (
            <div>
                <div className="section-top has-subheader-index col-12">
                    <div className="breadcrumbs">
                        <Link to={"/students"}>Cursisten</Link>
                    </div>
                    <h1>
                        {this.props.title ? this.props.title : "Cursist ophalen..."}
                        &nbsp; <span className="lighter subtitle">{this.props.nibhv_number}</span>
                    </h1>

                    {buttons}

                    <div className="subheader-index">
                        <Link to={`/students/view/${this.props.studentUUID}`} activeClassName="active">
                            Gegevens
                        </Link>
                        <Link to={`/students/courses/${this.props.studentUUID}`} activeClassName="active">
                            Cursussen
                        </Link>
                        {/*<Link to={`/students/competenceprofiles/${this.props.studentUUID}`} activeClassName="active">Competentieprofielen</Link>*/}
                        {/*<Link to={`/students/certificates/${this.props.studentUUID}`} activeClassName="active">Certificaten</Link>*/}
                        <Link to={`/students/files/${this.props.studentUUID}`} activeClassName="active">
                            Bestanden
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}
